module.exports = __webpack_public_path__ + "img/symbol_10.8e631a3c.png";